import React, { useEffect } from "react";
import Digitalfactorybanner from "./Digitalfactorybanner";
import Digitalfactoryabout from "./Digitalfactoryabout";
import Digitalfactoryfeatures from "./Digitalfactoryfeatures";
import Digitalfactorycards from "./Digitalfactorycards";
import Webbanner from "./Webbanner";

const Digitalfactory = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Digitalfactorybanner/>
      
      <Digitalfactoryabout/>

      <Digitalfactoryfeatures/>
      <Digitalfactorycards/>
    </div>
  );
};

export default Digitalfactory;
